import { Polyline } from "@react-google-maps/api"
import React from "react"
export default function ReccomendationPolyline({ path, isSelected }) {
  return (
    <Polyline
      options={{
        strokeColor: "#FFDC42",
        strokeOpacity: isSelected ? 1 : 0.3,
        strokeWeight: isSelected ? 4 : 3,
      }}
      path={path}
    />
  )
}
